export default {
  title: 'light',

  colors: {
    primary: '#323C79',
    info: '#169bd6',
    secundary: '#D5DEE5',

    background: '#F7FAFC',
    shape_primary: '#ffffff',
    background_gradient:
      'linear-gradient(90deg, #050059 0%, #090979 28.13%, rgba(17, 27, 145, 0.98) 100%),#ffffff',
    title: '#2F2E38',
    text: '#2F2E38',
    disabled: '#cecece',
    link: '#666',
    link_light: '#fff',

    menu_link: '#A0A0A0',
    menu_sublink: '#A0A0A0',
    menu_title: '#7D7D7D',

    shape_input: '#f4f5f75e',
    shape_border_input: '#f4f5f7fa',
    placeholder_input: '#666360',
    text_input: '#2F2E38',

    table_title: '#2F2E38',
    table_text: '#8694A0',
    table_text_hover: '#1f1f1f',

    shape_row: '#f4f5f7fa',

    danger: '#E24A4A',
    success: '#09CC1D',
    notification: '#76A1DF',
    warning: '#FFA11A',
  },

  fonts: {},
};
